import React, { ReactNode, useState } from "react";
import { OverlayComponent, OverlayPosition } from "shared/components/overlay";
import { SettingsContainerExpandedComponent, SettingsContainerCollapsedComponent, SettingsContainerProps, SettingsContainerTitleProps } from "./SettingsContainer";


export interface PageContainerProps {
	settingsTitleChild: (props: SettingsContainerTitleProps) => ReactNode;
	settingCompactModeShowButtonText: string;

	settingsContentChild: ReactNode;
	settingsActionsChild?: ReactNode;
	contentChild: ReactNode;
	defaultIsSettingsExpanded: boolean;
}

export const PageContainerDesktopComponent = (props: PageContainerProps) => {
	const [isExpanded, setIsExpanded] = useState(props.defaultIsSettingsExpanded);

	const settingsContainerProps: SettingsContainerProps = {
		settingTitleChild: props.settingsTitleChild,
		contentChild: props.settingsContentChild,
		actionsChild: props.settingsActionsChild,
		setIsExpanded: setIsExpanded
	};

	return (
		<div className="page-with-settings">
			<div className="settings-wrapper">
				{
					isExpanded
						? <SettingsContainerExpandedComponent {...settingsContainerProps} />
						: <SettingsContainerCollapsedComponent {...settingsContainerProps} />
				}
			</div>
			<div className="content-wrapper">
				{ props.contentChild }
			</div>
		</div>
	);
}

export const PageContainerCompactComponent = (props: PageContainerProps) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const settingsContainerProps: SettingsContainerProps = {
		settingTitleChild: props.settingsTitleChild,
		contentChild: props.settingsContentChild,
		actionsChild: props.settingsActionsChild,
		setIsExpanded: setIsExpanded
	};

	return (
		<div className="page-with-settings">
			<div className="content-wrapper">
				{ props.contentChild }
			</div>
				{
					isExpanded
						? (
							<OverlayComponent key="settings-content" dropShadow={true} position={OverlayPosition.Fill} onShadowClick={() => setIsExpanded(false)}>
								<div className="settings-wrapper">
									<SettingsContainerExpandedComponent {...settingsContainerProps} />
								</div>
							</OverlayComponent>
						)
						: (
							<OverlayComponent key="settings-toggle" dropShadow={false} position={OverlayPosition.Bottom}>
								<div className="settings-actions">
									<button className="settings-action" onClick={() => setIsExpanded(true)}>{props.settingCompactModeShowButtonText}</button>
								</div>
							</OverlayComponent>
						)
				}
		</div>
	);
}